// Import GSAP core and the ScrollTrigger plugin
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Check if element exists first
if (document.querySelector('.locations-block')) {
    // Create a master timeline to sequence the animations of each .location element
    const locationsTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.locations-block',
            start: 'top 85%',
            end: 'bottom 85%',
            scrub: 3,
            toggleActions: 'play none none reverse',
        },
    });

    // Iterate over each location and create a sub-timeline for each
    document.querySelectorAll('.location').forEach((location) => {
        const text = location.querySelector('strong');
        const address = location.querySelector('address');
        const images = location.querySelectorAll('img');

        // Create a sub-timeline for each location
        const locationTimeline = gsap.timeline();

        // Animate the strong element
        locationTimeline.from(text, {
            x: '-7%',
            opacity: 0,
            duration: 5,
            ease: 'power1.inOut',
        });

        // Conditionally animate the address from the opposite direction
        if (address) {
            locationTimeline.from(address, {
                x: '7%',
                opacity: 0,
                duration: 5,
                ease: 'power1.inOut',
            }, '-=1.2');
        }

        // Animate the images
        locationTimeline.from(images, {
            x: '-7%',
            opacity: 0,
            duration: 5,
            ease: 'power1.inOut',
            stagger: 0.2,
        });

        // Add this location's timeline to the master timeline
        locationsTimeline.add(locationTimeline);
    });
}
